import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.OrderPage.components.IncidentsPane.title',
    defaultMessage: 'Incidents Pane',
  },
})
